import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { isExternalUser as fncIsExternalUser, isRoot as fncIsRoot } from "@/utils";

const {mapActions: mapMasterActionsMixin } = createNamespacedHelpers('Master')

Vue.mixin({
  data: function () {
    return {
      actionID: '',
      isChoose: [''],
      tableName: '',
      created: false
    }
  },
  computed: {
    isExternalUser () {
     return fncIsExternalUser();
    },
    isRoot () {
      return fncIsRoot();
    }
  },
  methods: {
    ...mapMasterActionsMixin(['updateSetDefaultMaster']),
    pms (permissions, service, callback) {
      const vm = this
      try {
        const result = vm.$store.state.permissions.find( res => {
          return res.subMenuName === permissions && res[service] === true
        })
        if(callback === "b"){
          return (result ? true : false)
        }else if(callback === "r"){
          if(result){
            return true
          }else{
            setTimeout(async () => {
              await vm.$router.push("/pages/not-authorized")
            }, 200);
          }
        }else{
          return false
        }
      } catch (error) {
        setTimeout(async () => {
          await vm.$router.push("/auth/login")
        }, 200);
      }
    },
    getStatusColor (status) {
      if (status === 'Enabled')   return 'success'
      if (status === 'Disabled') return 'danger'
      return 'primary'
    }, //"pms" function check permissions "permissions" get name of submenu "service" get ['visible','create','edit','delete'] visible create edit delete "callback" get ["b","r"] return boolean or redirect
    getStatusAction (status) {
      let color = ""
      let txt = ""
      if (status) {
        color = 'success'
        txt = 'ปกติ'
      } else {
        color = 'danger'
        txt = 'ยกเลิก'
      }
      return { color: color, txt: txt }
    },
    generateOtpRef() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      const otpLength = 6;
      let otpRef = '';

      for (let i = 0; i < otpLength; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        otpRef += characters[randomIndex];
      }

      return otpRef;
    },
  },
  watch: {
    isChoose: {
      async handler(res, oRes){
        const vm = this
        let id = ""
        if(vm.isChoose.length > 1){
          vm.isChoose.shift()
        }
        if(res !== oRes && oRes[0] !== ''){
          if(vm.isChoose.length >= 1){
            id = vm.isChoose[0]
          }
          vm.updateSetDefaultMaster({
            id,
            form: {tableName: this.tableName},
            vm: null,
            redirect: null
          })
        }
      },
      deep: true
    }
  },
})
